import React, { useState } from 'react';
import styled from 'styled-components';
import vw from 'src/styles/utils';
import Helmet from 'react-helmet';
import Legal from 'src/pages/LegalForm/Legal';

import FormHeader from 'components/FormHeader/FormHeader';
import LegalContact from './LegalContact';

const LegalForm = () => {
  const [legalContactOpen, setLegalContactOpen] = useState(false);
  return (
    <>
      <Helmet
        meta={[
          {
            name: 'robots',
            content: 'noindex,nofollow',
          },
        ]}
      />
      <FormHeader />
      <Root>
        {legalContactOpen && (
          <LegalContact setLegalContactOpen={setLegalContactOpen} />
        )}
        <Title>
          <h2 className="strapline">
            THE AMAZING BRENTWOOD
            <br />
            <span>TOWER 5</span>
          </h2>
          <h1>Lawyer / Notary Submission</h1>
          <br />
          <br />
        </Title>
        <Legal setLegalContactOpen={setLegalContactOpen} />
      </Root>
    </>
  );
};

const Root = styled.main`
  ${vw('padding-top', 42, 75, 122)}
  ${vw('padding-bottom', 66, 99, 105)}
  ${vw('padding-left', 25, 60, 100)}
  ${vw('padding-right', 25, 60, 200)}
 font-family: Big Caslon;
`;

const Title = styled.div`
  h1 {
    ${vw('margin-top', 20)}
    font-family: Gotham Black;
    ${vw('font-size', 18, 30)}
  }

  h2 {
    font-family: Gotham Black;
    ${vw('font-size', 18, 50)}
  }
  span {
    color: #de5647;
  }
`;

export default LegalForm;

const Line = styled.div`
  background-color: #000;
  ${vw('width', 40)}
  ${vw('height', 4)}
  ${vw('margin-top', 50)}
  ${vw('margin-bottom', 50)}
`;
